import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function chevronLeft({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M4.707.293a1 1 0 010 1.414L2.414 4l2.293 2.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default chevronLeft;
